import { createApi } from '@reduxjs/toolkit/query/react';

import {
  SettingsEndpoints as Endpoints,
  type GetJournalSettingsRequest,
  type GetJournalSettingsResponse,
  type GetLeadsFreeOwnerTimeoutRequest,
  type GetLeadsFreeOwnerTimeoutResponse,
  type SetJournalSettingsRequest,
  type SetJournalSettingsResponse,
  type SetLeadsFreeOwnerTimeoutRequest,
  type SetLeadsFreeOwnerTimeoutResponse,
} from '@app/api/Settings/types';
import { createApiBaseQuery, Methods } from '@app/api/shared';

const SETTINGS_CHUNK = 'Settings';

export const settingsApi = createApi({
  reducerPath: 'settingsApi',
  baseQuery: createApiBaseQuery(SETTINGS_CHUNK),
  endpoints: ({ mutation, query }) => ({
    GetJournalSettings: query<
      GetJournalSettingsResponse,
      GetJournalSettingsRequest
    >({
      query: ({ logs, ...params }) => ({
        url: Endpoints.GetJournalSettings,
        method: Methods.GET,
        params,
        logs,
      }),
    }),
    SetJournalSettings: mutation<
      SetJournalSettingsResponse,
      SetJournalSettingsRequest
    >({
      query: ({ data, ...params }) => ({
        url: Endpoints.GetJournalSettings,
        method: Methods.POST,
        params,
        data,
      }),
    }),
    GetLeadsFreeOwnerTimeout: query<
      GetLeadsFreeOwnerTimeoutResponse,
      GetLeadsFreeOwnerTimeoutRequest
    >({
      query: (params) => ({
        url: Endpoints.GetLeadsFreeOwnerTimeout,
        method: Methods.GET,
        params,
      }),
    }),
    SetLeadsFreeOwnerTimeout: mutation<
      SetLeadsFreeOwnerTimeoutResponse,
      SetLeadsFreeOwnerTimeoutRequest
    >({
      query: ({ ActiveBranchId, Value }) => ({
        url: Endpoints.SetLeadsFreeOwnerTimeout,
        method: Methods.POST,
        params: { ActiveBranchId },
        data: { Value },
      }),
    }),
  }),
});

export const {
  useGetJournalSettingsQuery,
  useLazyGetJournalSettingsQuery,
  useSetJournalSettingsMutation,
  useGetLeadsFreeOwnerTimeoutQuery,
  useLazyGetLeadsFreeOwnerTimeoutQuery,
  useSetLeadsFreeOwnerTimeoutMutation,
} = settingsApi;
